import React from "react";
import { logoAmexWhite, logoCandadoWhite, logoKueskiWhite, logoMasterCardWhite, logoMercadoLibreWhite, logoPaypalWhite, logoVisaWhite, logoVtexWhite } from "../../../assets/ImgLinks";
//import imgFooter from "./images/footerLogo.png";
import './Sections.css';

const Terms = () => {
  return (
    <div className="m-3 bg-dark text-secondary p-2 text-center">
      

      {/* <div className="d-none d-lg-flex align-items-center justify-content-center">
        <img style={{width:'150px'}} src={logoVtexWhite} alt="logoVtexWhite" />
        <img src={logoCandadoWhite} alt="logoCandadoWhite" />
        <h6 className="fw-light mx-2 fs-5 darkerHover">Pago Seguro Con</h6>
        <img src={logoMercadoLibreWhite} alt="logoMercadoLibre" />
        <img className="mx-2" src={logoPaypalWhite} alt='logoPaypalWhite' />
        <img src={logoVisaWhite} alt="logoVisaWhite" />
        <img className="mx-2"src={logoMasterCardWhite} alt="logoMasterCardWhite" />
        <img src={logoAmexWhite} alt="logoAmexWhite" />
        <img className="mx-2"src={logoKueskiWhite} alt="logoKueskiWhite" />
      </div> */}

      <ul className="row">
        <p className="col-12 col-lg-6 mt-3">
          Miniso México. Todos los derechos reservados © 2021
        </p>
        <li
          className="col-12 col-md-6 col-lg-3 mt-3"
          style={{ listStyle: "none" }}
        >
          {" "}
          <a style={{ color: "inherit" }} href="https://www.miniso.com.mx/terminos-y-condiciones">
            Terminos y Condiciones
          </a>{" "}
        </li>
        <li
          className="col-12 col-md-6 col-lg-3 mt-3"
          style={{ listStyle: "none" }}
        >
          {" "}
          <a style={{ color: "inherit" }} href="https://www.miniso.com.mx/aviso-de-privacidad">
            Aviso de Privacidad
          </a>{" "}
        </li>
      </ul>

      <p className="d-lg-none">
        Miniso.com.mx utiliza cookies para que tengas la mejor experiencia de
        navegación. Si sigues navegando entendemos que aceptas nuestra politica de cookies.
      </p>
      <p className="d-none d-lg-block">
        Miniso.com.mx utiliza cookies a través de las que se obtienen datos
        personales de los clientes. Puedes deshabilitar estas cookies desde la
        configuración de tu navegador. Si continúas navegando en el sitio,
        entendemos que aceptas el uso de las cookies descrito en nuestro Aviso
        de Privacidad.
      </p>
    </div>
  );
};

export default Terms;
